'use client';

import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { useHotelPages } from '../../hooks/useHotelPages';
import HotelCard from './hotelCard';
import useHideOnSite from '../../hooks/useLanguageFilter';

const HotelListing = ({ blok, hotels, destination, season, priceType }) => {
  const hotelPages = useHotelPages(blok.hotels);

  if (useHideOnSite(blok.hide_on_site)) return null;

  let items = [];

  if (hotelPages && hotels) {
    items = hotels.reduce((hotelsCombined, hotel) => {
      const matchingHotelPage = hotelPages.find(
        (hotelPage) => hotelPage.field_hotel_id_string === hotel.id,
      );
      if (matchingHotelPage) {
        const combo = { ...hotel, ...matchingHotelPage };
        hotelsCombined.push(combo);
      }
      return hotelsCombined;
    }, []);

    items.sort((a, b) => {
      const indexA = hotelPages.findIndex(
        (hotelPage) => hotelPage.field_hotel_id_string === a.id,
      );
      const indexB = hotelPages.findIndex(
        (hotelPage) => hotelPage.field_hotel_id_string === b.id,
      );
      return indexA - indexB;
    });
  }

  const gridColumns = blok.horizontal_scroll
    ? 'grid-flow-col auto-cols-[8vw] scroll-hide overflow-x-auto no-scrollbar max-w-screen-xl'
    : 'grid-cols-12 max-w-screen-xl';

  return (
    <section
      className={`relative col-span-12 scroll-mt-12 ${
        blok.horizontal_scroll ? 'flex-col' : ''
      } justify-center w-full`}
      {...storyblokEditable(blok)}
      id="hotels"
    >
      <h1 className="col-span-12 px-4 md:px-8 mt-12">{blok.title}</h1>
      <div
        className={`relative w-full h-auto grid gap-2 md:gap-4 ${gridColumns} mx-auto`}
        id={blok._uid}
      >
        {items.map((hotelCard) => {
          return (
            <HotelCard
              hotel={hotelCard}
              season={season}
              destination={destination}
              key={hotelCard.id}
              priceType={hotelCard.hasPackage ? 'package' : null}
            />
          );
        })}
      </div>
    </section>
  );
};

export default HotelListing;
